import axios from "axios";

import {
  GET_CLASSACTIVITY,
  RESET_CLASSACTIVITY,
  LOADING
} from "../actionTypes";
import { DEV_EM_APIS_URL, AWS_SERVER_APIS } from "configurations";
import { adminTokenDev, adminToken } from "../../helper";

const { SET_TRUE, SET_FALSE } = LOADING;

export const get = () => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminToken()
      .then(token =>
        axios.get(
          `${AWS_SERVER_APIS}/get-class-booking`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch({ type: GET_CLASSACTIVITY, payload: res.data.data });
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};


export const reset = () => dispatch => dispatch({ type: RESET_CLASSACTIVITY });
